__turbopack_context__.v({
  "buttonAttachedSubtitle": "CampaignHeroBanner-module__2JnSJG__buttonAttachedSubtitle",
  "contentSection": "CampaignHeroBanner-module__2JnSJG__contentSection",
  "contentTextContainer": "CampaignHeroBanner-module__2JnSJG__contentTextContainer",
  "cta": "CampaignHeroBanner-module__2JnSJG__cta",
  "heroFadeIn": "CampaignHeroBanner-module__2JnSJG__heroFadeIn",
  "heroSection": "CampaignHeroBanner-module__2JnSJG__heroSection",
  "scrim": "CampaignHeroBanner-module__2JnSJG__scrim",
  "subtitle": "CampaignHeroBanner-module__2JnSJG__subtitle",
  "title": "CampaignHeroBanner-module__2JnSJG__title",
});
